var map = {
	"./about-us/facebook": 185,
	"./about-us/facebook.svg": 185,
	"./about-us/instragram": 186,
	"./about-us/instragram.svg": 186,
	"./about-us/twitter": 187,
	"./about-us/twitter.svg": 187,
	"./about-us/youtube": 188,
	"./about-us/youtube.svg": 188,
	"./account-create/account-img": 189,
	"./account-create/account-img.png": 189,
	"./account/camera-white-icon": 190,
	"./account/camera-white-icon.svg": 190,
	"./account/edit-icon": 191,
	"./account/edit-icon.svg": 191,
	"./account/edit-img": 192,
	"./account/edit-img.png": 192,
	"./account/icon1": 193,
	"./account/icon1.svg": 193,
	"./account/icon2": 194,
	"./account/icon2.svg": 194,
	"./account/icon3": 195,
	"./account/icon3.svg": 195,
	"./account/icon4": 196,
	"./account/icon4.svg": 196,
	"./account/icon5": 197,
	"./account/icon5.svg": 197,
	"./account/icon6": 198,
	"./account/icon6.svg": 198,
	"./account/icon7": 199,
	"./account/icon7.svg": 199,
	"./account/icon8": 200,
	"./account/icon8.svg": 200,
	"./account/profile-img": 201,
	"./account/profile-img.png": 201,
	"./bg-3": 39,
	"./bg-3.jpg": 39,
	"./contact-us/call-icon": 202,
	"./contact-us/call-icon.svg": 202,
	"./contact-us/contact-us-img": 203,
	"./contact-us/contact-us-img.png": 203,
	"./contact-us/message-icon": 204,
	"./contact-us/message-icon.svg": 204,
	"./favicon/icon": 205,
	"./favicon/icon.png": 205,
	"./finger-print/congratulation": 206,
	"./finger-print/congratulation.png": 206,
	"./finger-print/finger-print-img": 207,
	"./finger-print/finger-print-img.png": 207,
	"./finger-print/print-border": 208,
	"./finger-print/print-border.png": 208,
	"./flag/flag-img": 209,
	"./flag/flag-img.png": 209,
	"./guide_no_avatar": 40,
	"./guide_no_avatar.png": 40,
	"./invite-friend/invite-1": 210,
	"./invite-friend/invite-1.png": 210,
	"./invite-friend/invite-2": 211,
	"./invite-friend/invite-2.png": 211,
	"./invite-friend/invite-3": 212,
	"./invite-friend/invite-3.png": 212,
	"./invite-friend/invite-4": 213,
	"./invite-friend/invite-4.png": 213,
	"./invite-friend/invite-5": 214,
	"./invite-friend/invite-5.png": 214,
	"./invite-friend/invite-6": 215,
	"./invite-friend/invite-6.png": 215,
	"./invite-friend/invite-7": 216,
	"./invite-friend/invite-7.png": 216,
	"./invite-friend/invite-8": 217,
	"./invite-friend/invite-8.png": 217,
	"./invite-friend/invite-9": 218,
	"./invite-friend/invite-9.png": 218,
	"./let-you-screen/Button - Back": 219,
	"./let-you-screen/Button - Back.svg": 219,
	"./let-you-screen/apple-icon": 220,
	"./let-you-screen/apple-icon.svg": 220,
	"./let-you-screen/bg-img": 221,
	"./let-you-screen/bg-img.svg": 221,
	"./let-you-screen/fb-icon": 222,
	"./let-you-screen/fb-icon.svg": 222,
	"./let-you-screen/google-icon": 223,
	"./let-you-screen/google-icon.svg": 223,
	"./let-you-screen/logo": 224,
	"./let-you-screen/logo.svg": 224,
	"./let-you-screen/whatsapp": 225,
	"./let-you-screen/whatsapp.svg": 225,
	"./location/enable-location-img": 226,
	"./location/enable-location-img.png": 226,
	"./map/add-address-img": 227,
	"./map/add-address-img.png": 227,
	"./map/airport": 228,
	"./map/airport.svg": 228,
	"./map/arrived-map": 229,
	"./map/arrived-map.png": 229,
	"./map/arrived-screen": 230,
	"./map/arrived-screen.png": 230,
	"./map/big-star": 231,
	"./map/big-star.svg": 231,
	"./map/bus": 232,
	"./map/bus.svg": 232,
	"./map/call": 233,
	"./map/call.svg": 233,
	"./map/car1": 234,
	"./map/car1.png": 234,
	"./map/car2": 235,
	"./map/car2.png": 235,
	"./map/car3": 236,
	"./map/car3.png": 236,
	"./map/car4": 237,
	"./map/car4.png": 237,
	"./map/check-icon": 238,
	"./map/check-icon.svg": 238,
	"./map/current-location": 239,
	"./map/current-location.svg": 239,
	"./map/date": 240,
	"./map/date.svg": 240,
	"./map/dollar": 241,
	"./map/dollar.svg": 241,
	"./map/driver1": 242,
	"./map/driver1.png": 242,
	"./map/edit": 243,
	"./map/edit.svg": 243,
	"./map/green-promocode": 244,
	"./map/green-promocode.svg": 244,
	"./map/home": 245,
	"./map/home.svg": 245,
	"./map/km": 246,
	"./map/km.svg": 246,
	"./map/left-arrow": 247,
	"./map/left-arrow.svg": 247,
	"./map/location": 248,
	"./map/location-work": 249,
	"./map/location-work.svg": 249,
	"./map/location.svg": 248,
	"./map/map-img": 250,
	"./map/map-img.png": 250,
	"./map/map2": 251,
	"./map/map2.png": 251,
	"./map/map3": 252,
	"./map/map3.png": 252,
	"./map/map4": 253,
	"./map/map4.png": 253,
	"./map/min": 254,
	"./map/min.svg": 254,
	"./map/minus-icon": 255,
	"./map/minus-icon.svg": 255,
	"./map/payment1": 256,
	"./map/payment1.svg": 256,
	"./map/payment2": 257,
	"./map/payment2.svg": 257,
	"./map/payment3": 258,
	"./map/payment3.svg": 258,
	"./map/payment4": 259,
	"./map/payment4.svg": 259,
	"./map/payment5": 260,
	"./map/payment5.svg": 260,
	"./map/plus-icon": 261,
	"./map/plus-icon.svg": 261,
	"./map/profile": 262,
	"./map/profile.png": 262,
	"./map/read_less_image": 263,
	"./map/read_less_image.svg": 263,
	"./map/read_more_image": 264,
	"./map/read_more_image.svg": 264,
	"./map/red-tick-icon": 265,
	"./map/red-tick-icon.svg": 265,
	"./map/rides-map-img": 266,
	"./map/rides-map-img.png": 266,
	"./map/school": 267,
	"./map/school.svg": 267,
	"./map/setting-icon": 268,
	"./map/setting-icon.svg": 268,
	"./map/slide-arrow": 269,
	"./map/slide-arrow.svg": 269,
	"./map/star": 270,
	"./map/star.svg": 270,
	"./map/swipe-arrow": 271,
	"./map/swipe-arrow.svg": 271,
	"./map/swipe-up-arrow": 272,
	"./map/swipe-up-arrow.svg": 272,
	"./map/time": 273,
	"./map/time.svg": 273,
	"./map/trip": 274,
	"./map/trip.svg": 274,
	"./map/work": 275,
	"./map/work.svg": 275,
	"./map/yellow": 276,
	"./map/yellow.svg": 276,
	"./notification/notification-img": 277,
	"./notification/notification-img.png": 277,
	"./payment/edit-icon": 278,
	"./payment/edit-icon.svg": 278,
	"./payment/left-icon": 279,
	"./payment/left-icon.png": 279,
	"./payment/visa-card": 280,
	"./payment/visa-card.png": 280,
	"./payment/visa-icon": 281,
	"./payment/visa-icon.png": 281,
	"./promocode/green-promocode": 282,
	"./promocode/green-promocode.svg": 282,
	"./promocode/promocode-icon": 283,
	"./promocode/promocode-icon.svg": 283,
	"./promocode/promocode-img": 284,
	"./promocode/promocode-img.png": 284,
	"./rewards/Icon": 285,
	"./rewards/Icon.svg": 285,
	"./rewards/bg-img": 286,
	"./rewards/bg-img.png": 286,
	"./rewards/entertainment1": 287,
	"./rewards/entertainment1.png": 287,
	"./rewards/entertainment2": 288,
	"./rewards/entertainment2.png": 288,
	"./rewards/food1": 289,
	"./rewards/food1.png": 289,
	"./rewards/food2": 290,
	"./rewards/food2.png": 290,
	"./rewards/shopping1": 291,
	"./rewards/shopping1.png": 291,
	"./rewards/shopping2": 292,
	"./rewards/shopping2.png": 292,
	"./rewards/white-right-arrow": 293,
	"./rewards/white-right-arrow.svg": 293,
	"./rides/driver1": 294,
	"./rides/driver1.png": 294,
	"./rides/driver2": 295,
	"./rides/driver2.png": 295,
	"./rides/driver3": 296,
	"./rides/driver3.png": 296,
	"./rides/driver4": 297,
	"./rides/driver4.png": 297,
	"./rides/driver5": 298,
	"./rides/driver5.png": 298,
	"./rides/icon1": 299,
	"./rides/icon1.svg": 299,
	"./rides/icon2": 300,
	"./rides/icon2.svg": 300,
	"./rides/icon3": 301,
	"./rides/icon3.svg": 301,
	"./rides/map-img": 302,
	"./rides/map-img.png": 302,
	"./setting/Icon10": 303,
	"./setting/Icon10.svg": 303,
	"./setting/Icon7": 304,
	"./setting/Icon7.svg": 304,
	"./setting/Icon8": 305,
	"./setting/Icon8.svg": 305,
	"./setting/Icon9": 306,
	"./setting/Icon9.svg": 306,
	"./setting/icon1": 307,
	"./setting/icon1.svg": 307,
	"./setting/icon2": 308,
	"./setting/icon2.svg": 308,
	"./setting/icon3": 309,
	"./setting/icon3.svg": 309,
	"./setting/icon4": 310,
	"./setting/icon4.svg": 310,
	"./setting/icon5": 311,
	"./setting/icon5.svg": 311,
	"./setting/icon6": 312,
	"./setting/icon6.svg": 312,
	"./spinner": 41,
	"./spinner.svg": 41,
	"./splash-screen/BG Shape": 313,
	"./splash-screen/BG Shape.svg": 313,
	"./splash-screen/logo": 314,
	"./splash-screen/logo.svg": 314,
	"./splash-screen/onboarding1": 315,
	"./splash-screen/onboarding1.png": 315,
	"./splash-screen/onboarding2": 316,
	"./splash-screen/onboarding2.png": 316,
	"./splash-screen/onboarding3": 317,
	"./splash-screen/onboarding3.png": 317,
	"./splash-screen/onboarding4": 318,
	"./splash-screen/onboarding4.png": 318,
	"./svg/back-btn-arrow": 319,
	"./svg/back-btn-arrow.svg": 319,
	"./svg/back-btn-white": 320,
	"./svg/back-btn-white.svg": 320,
	"./svg/dollar-icon": 321,
	"./svg/dollar-icon.svg": 321,
	"./svg/down-arrow": 322,
	"./svg/down-arrow.svg": 322,
	"./svg/faq-up": 323,
	"./svg/faq-up.svg": 323,
	"./svg/language-icon": 324,
	"./svg/language-icon.svg": 324,
	"./svg/minus-icon": 325,
	"./svg/minus-icon.svg": 325,
	"./svg/package-icon": 326,
	"./svg/package-icon.png": 326,
	"./svg/plus-icon": 327,
	"./svg/plus-icon.svg": 327,
	"./svg/processing-loader": 328,
	"./svg/processing-loader.svg": 328,
	"./svg/up-arrow": 329,
	"./svg/up-arrow.svg": 329,
	"./taxigo-platinum/bg-img": 330,
	"./taxigo-platinum/bg-img.png": 330,
	"./taxigo-platinum/cup-icon": 331,
	"./taxigo-platinum/cup-icon.svg": 331,
	"./taxigo-platinum/offers": 332,
	"./taxigo-platinum/offers.svg": 332,
	"./taxigo-platinum/points": 333,
	"./taxigo-platinum/points.svg": 333,
	"./taxigo-platinum/support": 334,
	"./taxigo-platinum/support.svg": 334,
	"./taxigo-platinum/work1": 335,
	"./taxigo-platinum/work1.svg": 335,
	"./taxigo-platinum/work2": 336,
	"./taxigo-platinum/work2.svg": 336,
	"./verify-number/verify-img": 337,
	"./verify-number/verify-img.png": 337,
	"./wallet/not-found-img": 338,
	"./wallet/not-found-img.png": 338,
	"./wallet/payment1": 339,
	"./wallet/payment1.svg": 339,
	"./wallet/payment2": 340,
	"./wallet/payment2.svg": 340,
	"./wallet/payment3": 341,
	"./wallet/payment3.svg": 341,
	"./wallet/payment4": 342,
	"./wallet/payment4.svg": 342,
	"./wallet/payment5": 343,
	"./wallet/payment5.svg": 343,
	"./wallet/payment6": 344,
	"./wallet/payment6.svg": 344,
	"./wallet/wallet-img": 345,
	"./wallet/wallet-img.png": 345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 518;